import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../../../../Theme';

import type { InputThemeProps } from '../../../utils/themes';

/**
 * Import Themes
 */

import inputFieldCommonTheme from './common';

import inputFieldBlogTheme from './_blog';
import inputFieldSiteTheme from './_site';

/**
 * Group Themes
 */

const inputFieldThemes = (fieldThemeProps: InputThemeProps) =>
  new MatchedMap([
    [ThemeEnum.Blog, inputFieldBlogTheme(fieldThemeProps)],
    [ThemeEnum.Site, inputFieldSiteTheme(fieldThemeProps)],
  ]);

/**
 * Theme Hook
 */

const useInputFieldTheme = (fieldThemeProps: InputThemeProps) =>
  useTheme(inputFieldCommonTheme, inputFieldThemes(fieldThemeProps));

export default useInputFieldTheme;
